import { useState } from "react"
import Modal from "../Modal"
import Button from "../Button"
import api from "../../services/api"

const DeleteOrganizationModal = ({ isOpen, onClose, onSuccess, organization }) => {
  const [deleting, setDeleting] = useState(false)
  const [error, setError] = useState(null)

  const handleDelete = async () => {
    if (!organization) return

    setDeleting(true)
    setError(null)

    try {
      await api.deleteOrganization(organization.id)
      onSuccess()
      onClose()
    } catch (err) {
      console.error('Failed to delete organization:', err)
      setError(err.response?.data?.message || 'Failed to delete organization')
    } finally {
      setDeleting(false)
    }
  }

  if (!organization) return null

  return (
    <Modal isOpen={isOpen} setIsOpen={onClose} width="md:max-w-screen-md">
      <div>
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center">
            <i className="fa fa-exclamation-triangle text-red-600 text-xl"></i>
          </div>
          <h2 className="text-2xl font-bold text-gray-900">Delete Organization</h2>
        </div>

        <div className="mb-6">
          <p className="text-gray-700 mb-4">
            Are you sure you want to delete <span className="font-semibold">{organization.name}</span>?
          </p>
          <div className="bg-red-50 border border-red-200 rounded-lg p-3">
            <p className="text-sm text-red-800 font-medium">
              <i className="fa fa-warning mr-2"></i>
              Warning: This action cannot be undone!
            </p>
            <p className="text-sm text-red-700 mt-2">
              All users in this organization will be affected. Make sure to reassign users before deleting.
            </p>
          </div>
        </div>

        {error && (
          <div className="mb-4 bg-red-50 border border-red-200 rounded-lg p-3">
            <p className="text-sm text-red-600">{error}</p>
          </div>
        )}

        <div className="flex justify-end gap-3">
          <Button
            type="button"
            variant="secondary-ghost"
            onClick={onClose}
            disabled={deleting}
          >
            Cancel
          </Button>
          <Button
            type="button"
            onClick={handleDelete}
            disabled={deleting}
            className="bg-red-600 hover:bg-red-700 text-white"
          >
            {deleting ? (
              <>
                <i className="fa fa-spinner fa-spin mr-2"></i>
                Deleting...
              </>
            ) : (
              <>
                <i className="fa fa-trash mr-2"></i>
                Delete Organization
              </>
            )}
          </Button>
        </div>
      </div>
    </Modal>
  )
}

export default DeleteOrganizationModal
